<template>
  <transition name="slide-down">
    <div v-if="showBanner" class="external-banner">
      <div>{{ $t("externalBrowser.message") }}</div>

      <!-- iOS → MUST use a real anchor tag -->
      <!--a
        v-if="isIOS"
        class="external-btn"
        :href="externalUrl"
        target="_blank"
        rel="noopener"
      >
        {{ $t("externalBrowser.button") }}
      </a-->

      <!-- Android → use Chrome intents -->
      <div v-if="isIOS" class="external-btn" @click="showBanner = false">
        {{ $t("externalBrowser.ignore") }}
      </div>
      <div v-else class="external-btn" @click="openInExternalBrowserAndroid">
        {{ $t("externalBrowser.button") }}
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "ExternalBrowserBanner",
  data() {
    return {
      showBanner: false,
      isIOS: /iPhone|iPad|iPod/i.test(navigator.userAgent),
      externalUrl: window.location.href,
    };
  },
  mounted() {

    this.isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);

    const ua = navigator.userAgent.toLowerCase();
    const isInstagram = ua.includes("instagram");
    const isFacebook = ua.includes("fbav") || ua.includes("fbios") || ua.includes("fban");
    const isMessenger = ua.includes("messenger");

    this.showBanner = isInstagram || isFacebook || isMessenger;
  },
  methods: {
    openInExternalBrowserAndroid() {
      const url = this.externalUrl;
      const androidUrl = url.replace(/^https?:\/\//, "");
      window.location.href = "googlechrome://" + androidUrl;
      setTimeout(() => {
        window.location.href = "intent://" + androidUrl + "#Intent;scheme=https;package=com.android.chrome;end";
      }, 300);
      setTimeout(() => {
        window.open(url, "_blank");
      }, 600);
    }
  }
};
</script>

<style scoped>
.external-banner {
  text-align: center;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999;
  width: 100%;
  background: linear-gradient(90deg, #ffcc00, #ff9500);
  color: #000;
  padding: 14px 18px;
  justify-content: space-between;
  align-items: center;
  font-weight: 500;
  font-size: 15px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.25);
}

.external-btn {
  background: #000;
  color: #fff;
  border: none;
  padding: 8px 18px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  transition: 0.2s;
  max-width: 200px;
  margin-top: 5px;
  margin-left: auto;
  margin-right: auto;
  display: block;
}
.external-btn:hover {
  opacity: 0.8;
}

.slide-down-enter-active {
  animation: slideDown 0.35s ease-out;
}
@keyframes slideDown {
  from {
    transform: translateY(-100%);
  }
  to {
    transform: translateY(0);
  }
}
</style>
